export const environment = {
  production: true,
  apiUrl: 'https://api.grioplus.com',
  s3BucketUrl: 'https://grio-plus.s3.ap-southeast-2.amazonaws.com',
};
